import React from 'react'

interface LabelProps {
    label: string;
    customCSS?: string;
    subLabel?: string
}

export default function Label({ label, customCSS = 'text-xs text-gray-700', subLabel = '' } : LabelProps) {
    return (
        <label className={`block font-medium mb-1.5 ${customCSS}`}>
            {label}<span className='ml-1 text-xs font-normal text-gray-500'>{subLabel}</span>
        </label>
    )
}
